import React from "react";
import { useUser } from "./useUser";
import { useTheme } from "@mui/material";
import { ThemeOption } from "types";

const useMode = () => {
  const { mode } = useUser();
  const theme = useTheme() as ThemeOption;
  const colorMode = theme.colorSchemes?.[mode];
  return colorMode;
};

export default useMode;
